import { validation } from '../validation/validation';
/**
 * Validator that requires the control's value to be an email
 */
export var email = validation('email');
//# sourceMappingURL=email.js.map